import type { CameraInfo } from '@/types'
import { formatKstDateTime } from '@/utils/datetime'

export function formatTime(ts: string | null): string {
  return formatKstDateTime(ts, '—')
}

export function relativeTime(ts: string | null): string {
  if (!ts) return '—'
  const diff = Math.floor((Date.now() - new Date(ts).getTime()) / 1000)
  if (diff < 60) return `${diff}s ago`
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`
  return `${Math.floor(diff / 86400)}d ago`
}

export function getNodesReturnPath(state: unknown): string {
  if (state && typeof state === 'object' && 'returnTo' in state) {
    const returnTo = (state as { returnTo?: unknown }).returnTo
    if (typeof returnTo === 'string' && (returnTo === '/nodes' || returnTo.startsWith('/nodes?'))) {
      return returnTo
    }
  }
  return '/nodes'
}

export function parseCapabilities(raw: string | null | undefined): Set<string> {
  if (!raw) return new Set()
  try {
    const parsed = JSON.parse(raw)
    if (Array.isArray(parsed)) {
      return new Set(parsed.map(String))
    }
  } catch {
    // Some older deployments stored comma-separated values.
  }
  return new Set(raw.split(',').map((part) => part.trim()).filter(Boolean))
}

export function normalizedRecordingStatus(status: CameraInfo['recording_status']): CameraInfo['recording_status'] {
  return status === 'recording' ? 'running' : status
}

export function cx(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ')
}
